export default __webpack_public_path__ + "static/media/bind.1f01f7fc.jpeg";